// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/installation.css
// module id = 1285
// module chunks = 34